import React, { lazy } from 'react';
import Loadable from '../../../components/Loadable';

import { ColorsProvider } from "../../../contexts/attributesContext/ColorContext";
import { SizesProvider } from "../../../contexts/attributesContext/SizeContext";
import { CategoryProvider } from "../../../contexts/categoryContext/CategoryContext";

const AttributeFragment = Loadable(lazy(() => import('./shared/AttributeFragment')));
const AddSize = Loadable(lazy(() => import('./create/AddSize')));
const AddColor = Loadable(lazy(() => import('./create/AddColor')));


const attributesRoutes = [
    { path: '/product/sizes', element: <SizesProvider><AttributeFragment type={1} /></SizesProvider> },
    { path: '/product/add_size', element: <CategoryProvider><SizesProvider><AddSize /></SizesProvider></CategoryProvider> },
    { path: '/product/add_size/:id', element: <CategoryProvider><SizesProvider><AddSize /></SizesProvider></CategoryProvider> },
    { path: '/product/add_color', element: <CategoryProvider><ColorsProvider><AddColor /></ColorsProvider></CategoryProvider> },
    { path: '/product/add_color/:id', element: <CategoryProvider><ColorsProvider><AddColor /></ColorsProvider></CategoryProvider> },
    { path: '/product/colors', element: <ColorsProvider><AttributeFragment type={0} /></ColorsProvider> },
];

export default attributesRoutes;
